import React from 'react';
import { createPortal } from 'react-dom';
import './StudentCountIcon.scss';
import { connect } from 'react-redux';
import StudentCountIcon from './StudentCountIcon';
import usePerformanceTiers from 'chameleon/src/hooks/usePerformanceTiers';

const StudentCountIcons = (props) => {
  const {
    rubricReference,
    maxScore,
    rubricReportData,
    assignmentReport,
    studentUrl,
    students,
    itemId,
    subjectId,
  } = props;

  const { performanceTiers } = usePerformanceTiers(subjectId);

  const scoreSelectorEl = document.querySelector(
    `.learnosity-item[data-reference='${rubricReference}'] fieldset`,
  );
  if (!scoreSelectorEl) {
    return null;
  }
  const portalElement = document.createElement('div');
  scoreSelectorEl.parentElement.insertBefore(portalElement, scoreSelectorEl);

  return createPortal(
    <div className="scoring-rubric-student-counts">
      {Array.from(Array(maxScore + 1).keys()).map((score) => (
        <StudentCountIcon
          key={score}
          rubricReference={rubricReference}
          score={score}
          rubricReportData={rubricReportData}
          assignmentReport={assignmentReport}
          performanceTiers={performanceTiers}
          studentUrl={studentUrl}
          students={students}
          itemId={itemId}
        />
      ))}
    </div>,
    portalElement,
  );
};

export default connect((state) => ({
  subjectId: state.subject.data.id,
}))(StudentCountIcons);
